import { render } from "./BannerImg.vue?vue&type=template&id=27197b3b"
import script from "./BannerImg.vue?vue&type=script&lang=js"
export * from "./BannerImg.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bapman/Sites/telemac-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__